export default function Close () 
{
    return (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 14.5L1 1.5" stroke="#5493DA" stroke-width="2"/>
        <path d="M1 14.5L14 1.5" stroke="#5493DA" stroke-width="2"/>
    </svg>
    )
}